'use strict';

module.exports = function (ngModule) {
    ngModule.directive('renderhtml', require('./renderhtml'));
}


/** WEBPACK FOOTER **
 ** ./src/changelog/directives/renderhtml/index.js
 **/